export default __webpack_public_path__ + "static/media/gnl4.2a77ad44.jpg";